import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import { IndicatorState } from '../../../models/indicator.models';
import { BadgeIndicatorComponent } from './badge-indicator.component';
import { IndicatorStates } from '../../../constants/indicators.constants';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BadgeIndicatorComponent],
  selector: 'ui-intensity-indicator',
  template: `
    <ui-badge-indicator
      [state]="state()"
      [value]="intensity()"
      [nominal]="nominal()"
      [percentage]="percentage()"
      [units]="units()"
      [unitsReference]="units()"
      [tooltipLabel]="'DISTRIBUTION_NETWORK.TABLE.NOMINAL'"
    />
  `,
})
export class IntensityIndicatorComponent {
  state = input<IndicatorState>(IndicatorStates.Default);
  intensity = input<number>(0);
  nominal = input<number>(0);
  percentage = input<number>(0);
   units = signal<string>('A')
}
